import React from 'react';
import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';

const ButtonStyles = css`
  display: inline-block;
  padding: ${({ small }) => (small ? '0.5rem 1rem' : '0.8rem 2rem')};
  background-color: ${({ theme, secondary }) =>
    secondary ? theme.colors.secondary : theme.colors.primary};
  color: ${props => props.theme.colors.white};
  border: none;
  border-radius: ${props => props.theme.borderRadius};
  font-weight: 500;
  font-size: ${({ small }) => (small ? '0.85rem' : '1rem')};
  cursor: pointer;
  z-index: 100 !important;
  transition: ${props => props.theme.transition};
  text-align: center;
  
  &:hover {
    background-color: ${({ theme, secondary }) =>
    secondary ? theme.colors.primary : theme.colors.secondary};
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  }
  
  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    
    &:hover {
      transform: none;
      box-shadow: none;
    }
  }
`;

const StyledButton = styled.button`
  ${ButtonStyles}
`;

const StyledLink = styled(Link)`
  ${ButtonStyles}
`;

const StyledExternalLink = styled.a`
  ${ButtonStyles}
`;

const Button = ({ children, to, href, secondary, small, ...props }) => {
  if (to) {
    return (
      <StyledLink to={to} secondary={secondary} small={small} {...props}>
        {children}
      </StyledLink>
    );
  }

  if (href) {
    return (
      <StyledExternalLink href={href} secondary={secondary} small={small} {...props}>
        {children}
      </StyledExternalLink>
    );
  }

  return (
    <StyledButton secondary={secondary} small={small} {...props}>
      {children}
    </StyledButton>
  );
};

export default Button;